import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { ServiceLayer } from '../../services/serviceLayer';
import { ChangeDetectionService } from '../../services/changeDetectionService';
import { DAO } from '../../modal/DAO'
import { MessageService } from 'primeng/api';
import _ from 'lodash';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Auth0UserService } from 'src/app/services/auth0UserService.service';
import { Settings } from 'src/app/services/settings';
import { AppConfig } from 'src/app/app.config';
import { Constants } from 'src/app/modal/ProjConstants.models';
import { PolicyContainerService } from './policy-container.service';

@Component({
  selector: 'app-policy-container',
  templateUrl: './policy-container.component.html',
  providers: [PolicyContainerService]
})
export class PolicyContainerComponent  implements OnInit {

  public showBanner:boolean = false;    
  public policyContainerService = inject(PolicyContainerService);
  @Output() notifyChidrenToRollbackPageData:EventEmitter<string>  = new EventEmitter<string>();
  constructor(
    private router: Router,
    public serviceLayer: ServiceLayer,
    public dao: DAO, public appConfig: AppConfig,
    private messageService: MessageService,
    public dataChangeService: ChangeDetectionService,
    private auth0UserService: Auth0UserService) {}

    ngOnInit(): void {
        this.auth0UserService.userLoaded$.subscribe(
          auth0User => {
            this.dao.PolicySubTemplate = '';
            this.dao.PolicyTemplate = '';
            if(!!auth0User?.sessionIsGood)
            {              
              if (!!auth0User?.agencyCode && auth0User.agencyCode.length >= 5)
              {
                this.dao.PolicySubTemplate = 'newsubmission';
                this.showBanner = true;                
              }
              else
              {                 
                 this.messageService.add({ key: 'toast', severity: 'error', summary: "You are not authorized to use this portal", detail: "You are not authorized to use this portal"});
              }
            }
            else if(!!this.auth0UserService?.myAuth0Config?.authorizationParams?.redirect_uri)
            {
              this.router.navigate([""]);
            }
            //
          }); 
    }

  public async Ok(type, data) {
    this.messageService.clear(type);
    document.body.style.pointerEvents = "visible";
    if(data == Constants.SUBMISSION_DECLINED || data == Constants.SUBMISSION_CANCELLED){
      setTimeout(() => {
        //redirect to WIP page
        this.dao.PolicySubTemplate = 'newsubmission';
        this.dao.PolicyTemplate = '';
      });  
    }
  }

  // ===== find any change occurs in model =====
  public ngDoCheck() {    
    this.serviceLayer.restrictAutoFill();
  }

  public receiveRollbackEvent(keyword){    
    this.notifyChidrenToRollbackPageData.emit(keyword);
  }
}
